import { http } from './config'

export default {

  getAllShifts: () => {
    return http.get('shifts')
  },

  getShiftById: (shiftID) => {
    return http.get('shifts/' + shiftID)
  }

}
